export default __webpack_public_path__ + "static/logo_bfm-8398b26cf126d645dc0ddc4417fc7975.png";